export const getQueryParams = (params: Record<string, any>) => {
  const qString: string[] = [];
  Object.entries(params).forEach(([key, item]) => {
    if (item !== undefined && item !== null && item.length !== 0) {
      if (Array.isArray(item)) {
        for (const value of item) {
          qString.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          );
        }
      } else {
        qString.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
      }
    }
  });
  const queryParams = qString.join('&');
  return queryParams;
};
